module.exports = __webpack_public_path__ + "static/media/2023_2024_TMEA_Region_20_Band_Policies.76ce8885.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/2023_2024_TMEA_Region_20_Band_Policies.pdf
// module id = 195
// module chunks = 0